module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAqCAQAAABfRhDxAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAHdElNRQfkBA0PDQ4foZleAAAAkUlEQVRIx2M0/s+AAI0MDUi8Cwz6DBQDJsqNGLVgsFvAwrARiXcDRW4/wwPKLWA0prEPhn4cjFowasGoBQwMLAwHkHgLGBYg8eYwqFDDAnsk3gEUOZPRKnN4WMDC8BGJ9wNF7jOKHJlgtEYbtWDUguFgAQvDBiTeCoYVSLx+BkVqWOCPxLuAIuc4WuGMWkAUAABDDBNM7p5LvQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu_2x.png
// module id = oBOg
// module chunks = 1